export const SEARCH_MEMBERS = "app/SEARCH_MEMBERS";
export const SEARCH_MEMBERS_RESULTS = "app/SEARCH_MEMBERS_RESULTS";
export const SEARCH_MEMBERS_LOADING = "app/SEARCH_MEMBERS_LOADING";
export const CHANGE_PAGE = "app/MEMBERS_CHANGE_PAGE";
export const DELETED_MEMBERS_RESULTS = "app/DELETED_MEMBERS_RESULTS";
export const CHANGE_PER_PAGE = "app/MEMBERS_CHANGE_PER_PAGE";
export const NEW_MEMBER = "app/NEW_MEMBER";

